import {
  Wrench, Zap, Paintbrush, HardHat, Hammer, Home, Key, SprayCan, TreePine,
  Snowflake, Truck, Grid3x3, Layers, Waves, Shield, Sun, Droplets, Construction,
  PaintRoller, Building2, DoorOpen, Blinds, Flame,
  type LucideIcon,
} from 'lucide-react'

/**
 * Canonical service-slug → icon map. Single source so the homepage, /services,
 * /ville and category pages all show the same per-métier icon instead of a
 * generic wrench everywhere.
 */
const SERVICE_ICONS: Record<string, LucideIcon> = {
  plomberie: Wrench,
  electricite: Zap,
  peinture: Paintbrush,
  renovation: HardHat,
  menuiserie: Hammer,
  toiture: Home,
  'couverture-zinguerie': Home,
  serrurerie: Key,
  nettoyage: SprayCan,
  jardinage: TreePine,
  climatisation: Snowflake,
  chauffage: Flame,
  demenagement: Truck,
  'carrelage-sol': Grid3x3,
  isolation: Layers,
  maconnerie: Construction,
  platrerie: PaintRoller,
  piscine: Waves,
  securite: Shield,
  'panneaux-solaires': Sun,
  terrassement: Construction,
  assainissement: Droplets,
  facade: Building2,
  vitrerie: DoorOpen,
  'stores-volets': Blinds,
  ramonage: Flame,
}

/** Icon component for a service slug (falls back to a wrench). */
export function iconForService(slug: string | null | undefined): LucideIcon {
  return (slug && SERVICE_ICONS[slug]) || Wrench
}
